import * as React from 'react';

import HFNCTherapy from './HFNCTherapy';
import MADTherapy from './MandibularAdvancementDevice';
import OtherTreatment from './OtherTreatment';
import OxygenTherapy from './OxygenTherapy';
import PAPTherapy from './PAPTherapy';
import PatientDoesNotWantRespiratorySupportTherapy from './PatientDoesNotWantRespiratorySupportTherapy';
import SurgicalTreatment from './SurgicalTreatment';
import type { TreatmentDocumentType } from '../definitions';

const TreatmentForm = ({ document }: IOwnProps): React.JSX.Element | null => {
  if (!document?._type) return null;
  switch (document?._type) {
    case 'papTherapy':
      return <PAPTherapy />;
    case 'hfncTherapy':
      return <HFNCTherapy />;
    case 'oxygenTherapy':
      return <OxygenTherapy />;
    case 'madTherapy':
      return <MADTherapy />;
    case 'sleepApneaSurgicalTreatment':
      return <SurgicalTreatment />;
    case 'otherTreatment':
      return <OtherTreatment />;
    case 'patientDoesNotWantRespiratorySupportTherapy':
      return <PatientDoesNotWantRespiratorySupportTherapy />;
  }
};

interface IOwnProps {
  document: IDocumentWithTypeV2<TreatmentDocumentType> | undefined;
}

export default TreatmentForm;
